import React from 'react';
import { legalDocs, type LegalDoc } from '../data/legal';
type FooterProps = {
  onOpenDoc: (doc: LegalDoc) => void;
};
export function Footer({
  onOpenDoc
}: FooterProps) {
  return <footer className="w-full bg-cream pb-28 pt-16 sm:pb-16" data-id="element-64" data-mp="32o4ao9g4a660">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-65" data-mp="32pp5m06cfr4e">
        <div className="flex flex-col items-center gap-8 border-t border-plum/10 pt-10 text-center" data-id="element-66" data-mp="36qhgexuv642s">
          <p className="font-display text-2xl tracking-wide text-plum" data-id="element-67" data-mp="3ug3gdnj28nbu">Me Elijo</p>

          <nav aria-label="Enlaces legales" data-id="element-68" data-mp="398xsbsbb070">
            <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-69" data-mp="37xvkgeim0i0">
              {legalDocs.map(doc => <li key={doc.id} data-id="element-70" data-mp="3qdf7jfucjgev">
                  <button type="button" onClick={() => onOpenDoc(doc)} className="text-sm text-ink/65 underline-offset-4 transition-colors hover:text-clay hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum" data-id="element-71" data-mp="3qcdu54puyhtz">
                    {doc.label}
                  </button>
                </li>)}
            </ul>
          </nav>

          <p className="max-w-2xl text-xs leading-relaxed text-ink/45" data-id="element-72" data-mp="3v89fujfim3iz">
            Este contenido tiene fines educativos y de crecimiento personal. No sustituye
            acompañamiento psicológico o médico profesional. Producto 100% digital: no se
            realizan envíos físicos.
          </p>

          <p className="text-xs text-ink/45" data-id="element-73" data-mp="34pafb4q00ju">
            © {new Date().getFullYear()} Ingrid Rosales. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}